const messageTypes = {
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
};

export default messageTypes;
